import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const isMobile = () => {
  return window.innerWidth < 768
}

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/features',
    name: 'features',
    component: () => import('../views/FeaturesView.vue')
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  },
  {
    path: '/password-reset',
    name: 'password-reset',
    component: () => import('../views/PasswordResetView.vue')
  },
  {
    path: '/enter-new-password/:username/:token',
    name: 'enter-new-password',
    component: () => import('../views/EnterNewPasswordCarddy.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    component: () => import('../views/SignupView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    beforeEnter: (to, from, next) => {
      if (isMobile()) {
        next('/dash')
      } else {
        next()
      }
    },
    component: () => import('../views/DashboardView.vue')
  },
  {
    path: '/dash',
    name: 'dash',
    component: () => import('../views/DashView.vue')
  },
  {
    path: '/dash/card',
    name: 'dash-card',
    component: () => import('../views/VirtualCardsView.vue')
  },
  {
    path: '/dash/buy-card',
    name: 'dash-buy-card',
    component: () => import('../views/BuyCardView.vue')
  },
  {
    path: '/dash/support',
    name: 'dash-support',
    component: () => import('../views/SupportView.vue')
  },
  {
    path: '/dash/referral',
    name: 'dash-referral',
    component: () => import('../views/ReferralView.vue')
  },
  {
    path: '/dash/subscription',
    name: 'dash-subscription',
    component: () => import('../views/SubscriptionView.vue')
  },
  {
    path: '/dash/card-details',
    name: 'dash-card-details',
    component: () => import('../views/DashView.vue') // Will update with actual component later
  },
  {
    path: '/dash/settings',
    name: 'dash-settings',
    component: () => import('../views/DashView.vue') // Will update with actual component later
  },
  {
    path: '/dash/transactions',
    name: 'dash-transactions',
    component: () => import('../views/DashView.vue') // Will update with actual component later
  },
  {
    path: '/dash/profile',
    name: 'dash-profile',
    component: () => import('../views/DashView.vue') // Will update with actual component later
  },
  {
    path: '/master-account',
    name: 'master-account',
    component: () => import('../views/MasterAccountView.vue')
  },
  {
    path: '/master-account-instant',
    name: 'master-account-instant',
    component: () => import('../views/MasterAccountInstantView.vue')
  },
  {
    path: '/analytics-dashboard',
    name: 'analytics-dashboard',
    component: () => import('../views/AnalyticsView.vue')
  },
  {
    path: '/analytics',
    name: 'analytics',
    component: () => import('../views/AnalyticsDashboardView.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/midjourney',
    name: 'midjourney',
    component: () => import('../views/instructions/midjourney.vue')
  },
  {
    path: '/google',
    name: 'google',
    component: () => import('../views/instructions/google.vue')
  },
  {
    path: '/playstation',
    name: 'playstation',
    component: () => import('../views/instructions/playstation.vue')
  },
  {
    path: '/travel',
    name: 'travel',
    component: () => import('../views/instructions/travel.vue')
  },
  {
    path: '/surfshark',
    name: 'surfshark',
    component: () => import('../views/instructions/surfshark.vue')
  },
  {
    path: '/iherb',
    name: 'iherb',
    component: () => import('../views/instructions/iherb.vue')
  },
  {
    path: '/googleplay',
    name: 'googleplay',
    component: () => import('../views/instructions/googleplay.vue')
  },
  {
    path: '/dropbox',
    name: 'dropbox',
    component: () => import('../views/instructions/dropbox.vue')
  },
  {
    path: '/paypal',
    name: 'paypal',
    component: () => import('../views/instructions/paypal.vue')
  },
  {
    path: '/youtube',
    name: 'youtube',
    component: () => import('../views/instructions/youtube.vue')
  },
  {
    path: '/adobe',
    name: 'adobe',
    component: () => import('../views/instructions/adobe.vue')
  },
  {
    path: '/canva',
    name: 'canva',
    component: () => import('../views/instructions/canva.vue')
  },
  {
    path: '/payment/success',
    name: 'payment-success',
    component: () => import('../views/PaymentSuccess.vue')
  },
  {
    path: '/payment/fail',
    name: 'payment-fail',
    component: () => import('../views/PaymentFail.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 80 // Offset for header
      }
    }
    return { top: 0 }
  }
})

// Handle window resize for mobile/desktop redirection
if (typeof window !== 'undefined') {
  let resizeTimer
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer)
    resizeTimer = setTimeout(() => {
      const currentRoute = router.currentRoute.value
      if (currentRoute.path === '/dashboard' && isMobile()) {
        router.push('/dash')
      } else if (currentRoute.path === '/dash' && !isMobile()) {
        router.push('/dashboard')
      }
    }, 250)
  })
}

export default router
